<template>
  <div class="check-in-photo">
    <label class="btn btn--default" for="check-in-photo-input">{{ photo ? "Replace photo" : "Add photo (optional)" }}</label>
    <input id="check-in-photo-input" type="file" accept="image/*" capture="environment" @change="load" />
    <button v-if="photo" type="button" class="btn btn--default" @click="remove">Remove photo</button>
    <p v-if="error" role="alert">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "PhotoCaptureComponent",
  emits: ["change"],
  data: () => ({ photo: null, error: "" }),
  methods: {
    remove() { this.photo = null; this.$emit("change", null); },
    async load(event) {
      this.error = "";
      const file = event.target.files?.[0];
      event.target.value = "";
      if (!file) return;
      try {
        let bitmap;
        try {
          bitmap = typeof createImageBitmap === "function" ? await createImageBitmap(file) : await this.loadImage(file);
        } catch (_) {
          bitmap = await this.loadImage(file);
        }
        const scale = Math.min(1, 640 / Math.max(bitmap.width, bitmap.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(bitmap.width * scale));
        canvas.height = Math.max(1, Math.round(bitmap.height * scale));
        canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        if (bitmap.close) bitmap.close();
        const data = canvas.toDataURL("image/jpeg", 0.8).split(",")[1];
        if (data.length * 0.75 > 2 * 1024 * 1024) throw new Error("Photo is too large. Please choose another one.");
        this.photo = { contentType: "image/jpeg", data };
        this.$emit("change", this.photo);
      } catch (error) {
        this.error = error.message === "Photo is too large. Please choose another one." ? error.message : "Unable to read photo. Please try another one.";
      }
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => { URL.revokeObjectURL(url); resolve(image); };
        image.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Invalid image")); };
        image.src = url;
      });
    },
  },
};
</script>
